
<template>
  <div>
    <v-dialog v-model="dialog" scrollable  persistent max-width="700px" transition="dialog-transition" >
      <v-card style="border-radius:12px">
        <v-card-title primary-title>
          <div class="headline mb-0">Envelope</div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-3">
          <v-col cols='12' align='center' v-if="loading_envelope" >
            <card-loading-transparent ></card-loading-transparent>
          </v-col>

          <v-expansion-panels class="elevation-0" v-model="pay_expansions" v-if="!loading_envelope && oneEnvelope.id">
            <!-- {{oneEnvelope}} -->
            <v-expansion-panel>
              <v-expansion-panel-header class='primary--text title'>Informações do envelope</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-container grid-list-xl>
                  <v-layout row wrap justify-space-around>
                    <v-flex xs5 sm4 md4>
                      <v-text-field readonly label="Criado em" :value="$moment(oneEnvelope?.created_at?.substring(0,10)+'T'+oneEnvelope?.created_at?.substring(11,19)).format('L, HH:mm') "></v-text-field>
                    </v-flex>
                    <v-flex xs5 sm4 md4>
                      <v-text-field readonly label="Criado por" :value="oneEnvelope.creator_name"></v-text-field>
                    </v-flex>
                    <v-flex xs4 sm4 md4>
                      <v-text-field readonly label="Código" :value="oneEnvelope.name"></v-text-field>
                    </v-flex>
                    <v-flex xs4 md4>
                      <v-text-field readonly label="Pagamentos" :value="oneEnvelope.total_payments"></v-text-field>
                    </v-flex>
                    <v-flex xs4 md3 v-if="oneEnvelope.checks_count">
                      <v-text-field readonly label="Cheques" :value="oneEnvelope.checks_count"></v-text-field>
                    </v-flex>
                    <v-flex xs4 v-if="oneEnvelope.checks_count">
                      <v-text-field readonly label="Total em cheques" prefix="R$ " v-currency="currency" :value="Number(oneEnvelope.total_in_checks).toFixed(2)"></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field readonly label="Total em dinheiro" prefix="R$ " v-currency="currency" :value="Number(oneEnvelope.total_in_cash).toFixed(2)"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-row>
                    <v-col cols="12" class="py-0">
                      <span class="text-subtitle-1">Anexo do envelope</span>
                      <FileAttachment :update_infos="{MODEL: 'Envelope', id: parseInt(oneEnvelope.id)}" :attached_file_url="oneEnvelope.attached_file_url" @newFileUrl="handleNewFileUrl" v-if="had_permission"></FileAttachment>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-textarea :value="oneEnvelope.comment" readonly prepend-icon="mdi-chat" label="Comentários"></v-textarea>
                  </v-row>                  
                  <v-layout row wrap justify-space-around>
                    <v-flex xs5 v-if="!oneEnvelope.all_confirmed">
                      <v-btn block rounded color="primary" class="font-weight-bold" @click="confirmWholeEnvelope()" :disabled="!can_confirm">
                        Confirmar todo envelope
                      </v-btn>
                    </v-flex>
                    <v-flex xs5 v-if="oneEnvelope.all_confirmed && !oneEnvelope.was_received">
                      <v-btn block rounded color="primary" class="font-weight-bold" @click="setReceivedEnvelope()" :disabled="!can_receive">
                        Envelope recebido pela diretoria
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel v-for="(pay, index) in oneEnvelope.payments?.data" :key="`pay-${pay.id}`">
              <v-expansion-panel-header class='d-flex align-center primary--text title'>
                <div class="d-flex align-center">
                  <DialogOrdersPayedBySource :payment_id="pay.attributes.id"></DialogOrdersPayedBySource>
                  <DownloadPaymentResume :payment_id="pay.attributes.id"></DownloadPaymentResume>
                </div>
                <span>
                  Pagamento {{index+1}}
                </span>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-container grid-list-xl>
                  <v-container grid-list-xl>
                    <v-layout row wrap justify-space-around>
                      <v-flex xs10 sm5>
                        <v-text-field readonly label="Pago em" :value="$moment(pay?.attributes?.payed_at?.substring(0,10)).format('L')"></v-text-field>
                      </v-flex>
                      <v-flex xs10 sm5>
                        <v-text-field readonly label="Cliente" :value="pay?.attributes?.client_name"></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap justify-space-around>
                      <v-flex xs5 sm5 v-if="pay?.attributes?.cash_value">
                        <v-text-field readonly label="Em dinheiro" prefix="R$ " v-currency="currency" :value="Number(pay?.attributes?.cash_value).toFixed(2)"></v-text-field>
                      </v-flex>
                      <v-flex xs12 v-if="pay?.attributes?.cash">
                        <v-layout row wrap justify-space-around>
                          <template v-if="pay?.attributes?.cash.status_id == status_id_map['Payed']">
                            <!-- <v-flex xs8 > -->
                              <!-- <v-btn :disabled="!isFinancial" block round class="font-weight-bold" color="success" @click="confirm_cash(index)"> <v-icon left style="font-size: 22px">mdi-check</v-icon> Dinheiro OK</v-btn> -->
                            <!-- </v-flex> -->
                          </template>
                          <template v-if="pay?.attributes?.cash.status_id == status_id_map['Concluded']">
                            <v-flex xs9>
                              <v-alert type="success" :value="true">
                                <h3>Pagamento em dinheiro já confirmado</h3>
                              </v-alert>
                            </v-flex>
                          </template>
                        </v-layout>
                      <v-divider></v-divider>
                      <v-divider></v-divider>
                      </v-flex>
                      <template v-if="pay?.attributes?.checks">
                        <v-flex xs5 sm4>
                          <v-text-field readonly label="Valor em cheque" prefix="R$ " v-currency="currency" :value="Number(pay?.attributes?.check_value).toFixed(2)"></v-text-field>
                        </v-flex>
                        <v-flex xs12 md12>
                          <v-expansion-panels>
                            <v-expansion-panel v-for="(ck, ck_i) in pay.attributes.checks.data" :key="`ck-${ck_i}`">
                              <v-expansion-panel-header class='primary--text'>
                                <div>
                                  Cheque {{ck_i+1}}
                                  <v-icon small color="primary" class="ml-4" v-if="ck.attributes.status_id != status_id_map['Payed']">mdi-check</v-icon> 
                                </div>
                              </v-expansion-panel-header>
                              <v-expansion-panel-content >
                                <v-container grid-list-lg>
                                  <v-layout row wrap justify-space-around>
                                    <v-flex xs10 sm5>
                                      <v-text-field readonly label="Banco" :value="ck.attributes.bank"></v-text-field>
                                    </v-flex>
                                    <v-flex xs5 sm3>
                                      <v-text-field readonly label="Agencia" :value="ck.attributes.agency"></v-text-field>
                                    </v-flex>
                                    <v-flex xs5 sm4>
                                      <v-text-field readonly label="Conta" :value="`${ck.attributes.account_number}-${ck.attributes.account_digit}`"></v-text-field>
                                    </v-flex>

                                    <v-flex xs5 sm3>
                                      <v-text-field readonly label="Num. Cheque" :value="ck.attributes.check_number"></v-text-field>
                                    </v-flex>
                                    <v-flex xs5 sm3>
                                      <v-text-field readonly label="Bom para" :value="$moment(ck.attributes.good_to).format('L')"></v-text-field>
                                    </v-flex>
                                    <v-flex xs5 sm4>
                                      <v-text-field readonly label="Valor" prefix="R$ " v-currency="currency" :value="Number(ck.attributes.value).toFixed(2)"></v-text-field>
                                    </v-flex>

                                    <v-flex xs7 sm6>
                                      <v-text-field readonly label="Nominal" :value="ck.attributes.nominal"></v-text-field>
                                    </v-flex>
                                    <v-flex xs5 sm6 v-if="ck.attributes.nominal_cpf">
                                      <v-text-field readonly label="CPF Nominal" v-mask="'###.###.###-##'" :value="ck.attributes.nominal_cpf"></v-text-field>
                                    </v-flex>
                                    <v-flex xs5 sm6 v-if="ck.attributes.nominal_cnpj">
                                      <v-text-field readonly label="CNPJ Nominal" v-mask="'##.###.###/####-##'" :value="ck.attributes.nominal_cnpj"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                      <v-layout row wrap justify-space-around>
                                        <template v-if="ck.attributes.status_id == status_id_map['Payed']">
                                          <!-- <v-flex xs8> -->
                                            <!-- <v-btn :disabled="!isFinancial" block round class="font-weight-bold" color="success" @click="confirm_check(index, ck_i)"><v-icon left style="font-size: 22px">mdi-check</v-icon> Cheque Ok</v-btn> -->
                                          <!-- </v-flex> -->
                                        </template>
                                        <template v-if="ck.attributes.status_id != status_id_map['Payed']">
                                          <v-flex xs9>
                                            <v-alert type="info" :value="true">
                                              <h3>Pagamento em cheque já confirmado</h3>
                                            </v-alert>
                                          </v-flex>
                                        </template>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>

                                  
                                </v-container>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </v-expansion-panels>
                        </v-flex>
                      </template>
                    </v-layout>
                  </v-container>
                </v-container>
                <FileAttachment :update_infos="{MODEL: 'Payment', id: parseInt(pay.id)}" :attached_file_url="pay.attributes.attached_file_url" @newFileUrl="handleNewFileUrl" v-if="had_permission"></FileAttachment>
              </v-expansion-panel-content>
            </v-expansion-panel>

          </v-expansion-panels>
          <v-alert type="success" :value="true" v-if="oneEnvelope.all_confirmed">
            <h3>Envelope totalmente confirmado!</h3>
          </v-alert>
          <v-alert type="success" color='accent' :value="true" v-if="oneEnvelope.was_received">
            <h3>Envelope recebido pela diretoria!</h3>
          </v-alert>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <f-btn close @click="dialog = false">Fechar</f-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <dialog-loading v-if="loading"></dialog-loading>
  </div>
</template>

<script>
import Api from '@/api/index';
import status from "@/_backoffice/_financial/mixins/status.js"
import {CurrencyDirective} from 'vue-currency-input'
import { mask } from'vue-the-mask'

export default {
  name: 'DialogOneEnvelope',
  mixins: [ status ],
  components: {
    FileAttachment: () => import('@/components/shared/FileAttachment.vue'),
    DialogOrdersPayedBySource: () => import("@/_backoffice/_financial/components/payment/shared/DialogOrdersPayedBySource.vue"),
    DownloadPaymentResume: () => import("@/_backoffice/_financial/components/payment/shared/DownloadPaymentResume.vue"),
  },
  props: {
    envelope_id: {
      type: [Number, String],
    },
    one_envelope: {
      type: Object,
    },
  },
  directives: {
    currency: CurrencyDirective,
    mask,
  },
  data() {
    return {
      currency:{
        currency: null,
        locale: 'en-EN',
        autoDecimalMode: true,
        decimalLength: 2,
        distractionFree:false,
      },

      pay_expansions: 0,
      dialog: false,
      loading_envelope: false,

      oneEnvelope: {},


      loading: false,
    }
  },
  methods: {
    handleNewFileUrl(){

    },
    setReceivedEnvelope(){
      var c1 = confirm('Envelope realmente recebido pela diretoria?')
      if (c1) {
        let noti = {
          type: 'success',
          msg: 'Recebido com sucesso'
        }
        this.loading = true
        Api.Envelope.receive_envelope(this.oneEnvelope.id).then(r=>r.data).then(r => {
          this.$emit('doneConfirm')
        }).catch(err=>{
          noti = {
            type: 'error',
            msg: `Erro: ${err}`
          }
          console.log({err});
        }).finally(()=>{
          this.addNotification(noti)
          this.loading = false
        })
      }

    },
    confirmWholeEnvelope(){
      var c1 = confirm('Certeza em aprovar todo o envelope?')
      if (c1) {
        let noti = {
          type: 'success',
          msg: 'Confirmado com sucesso'
        }
        this.loading = true
        Api.Envelope.confirm_envelope(this.oneEnvelope.id, this.current_user_employee_id).then(r=>r.data).then(r => {
          this.$emit('doneConfirm')
        }).catch(err=>{
          noti = {
            type: 'error',
            msg: `Erro: ${err}`
          }
          console.log({err});
        }).finally(()=>{
          this.addNotification(noti)
          this.loading = false
        })
      }
    },
    showEnvelope() {
      this.loading_envelope = true
      this.dialog = true
      Api.Envelope.show(this.envelope_id).then(r=>r.data).then(r => {
        this.oneEnvelope = {id: r.data.id, ...r.data.attributes }
        this.pay_expansions = 0
      }).catch(err=>{
        console.log({err});
      }).finally(()=>{
        this.loading_envelope = false
      })
    },

  },
  computed: {
    can_confirm() {
      return this.has_roles(['Supervisor', 'Manager', 'Financial', 'Analyst', 'Director', 'SalesExecutive']) 
    },
    can_receive() {
      return this.has_roles(['Financial', 'Director']) 
    },
    had_permission(){
      return !this.isCreditAnalyst();
    }
  },
  watch: {
    envelope_id(nv,ov) {
      if (nv){
        this.showEnvelope()
      } else if (nv == false || nv == null){
        this.dialog = false
      }
    },
    dialog(nv,ov) {
      if (nv){
    
      } else if (nv == false){
        this.$emit('closeDialog')
      }
    }
  },
}
</script>
